<template>
  <div id="app">
    <div id="nav">
      <Navigation
        :nav-links="navLinks"
        :image-path="require('./assets/logo.png')"
      />
    </div>
    <!-- / nav -->
    <router-view :key="$route.fullPath"></router-view>
    <!-- cookie bar -->
    <footer>
      <cookie-law theme="customrise">
        <div slot-scope="props">
          <p>
            {{ strings.cookiesText }}
            <router-link to="privacypolicy">{{
              strings.cookiesCta
            }}</router-link>
          </p>
          <button class="skew Cookie__button" @click="props.accept">
            <span>{{ strings.cookiesOk }}</span>
          </button>
        </div>
      </cookie-law>
    </footer>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation";
import CookieLaw from "vue-cookie-law";
import axios from "axios";
import router from "./router";
import { bus } from "./main";

export default {
  components: { CookieLaw, Navigation },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Rise Ap.Art | Homes for elevated living",
    // all titles will be injected into this template
    titleTemplate: "%s",
    content:
      "Rise Ap.Art este un brand care dezvoltă proiecte rezidențiale de tip boutique pentru elevarea calității vieții."
  },
  data: () => ({
    navLinks: [
      {
        text: "getinvolved",
        path: "/getinvolved"
      },
      {
        text: "proposal",
        path: "/proposal"
      },
      {
        text: "project",
        path: "/project"
      }
    ],
    locale: "ro",
    strings: {
      cookiesText: "",
      cookiesCta: "",
      cookiesOk: ""
    }
  }),
  methods: {
    fetchData: function() {
      var self = this;

      // get translatable strings
      axios
        .get("https://api.riseapart.com/content?_limit=100", {
          headers: {
            "X-Locale": self.locale
          }
        })
        .then(function(data) {
          let stringsObj = data.data.data;
          let x;

          for (x = 0; x < stringsObj.length; x++) {
            let newObj = stringsObj[x];
            let newKey = Object.keys(newObj);
            self.strings[newObj[newKey].key] = newObj[newKey].value;
          }

          // console.log("strings2: ", self.strings);
        })
        .catch(function(error) {
          console.log("Error", error);
        });
    }
  },
  created() {
    // langCheck
    if (!this.$route.query.lang) {
      router.push({ query: { lang: "ro" } });
      this.locale = "ro";
    } else {
      this.locale = this.$route.query.lang;
      // console.log(this.locale);
      this.fetchData();
    }

    // lang switch
    bus.$on("lang", data => {
      this.locale = data.lang;
      router.push({ query: { lang: this.locale } });
      this.fetchData();
    });
  },
  watch: {
    "$route.params": {
      handler() {
        this.fetchData();
      },
      immediate: true
    },
    "$route.query": {
      handler() {
        this.fetchData();
      }
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/styles/_variables.scss";
@import "~@/assets/styles/_fonts.scss";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#nav {
  display: block;
  width: 100%;
}

/* cookie bar */
.Cookie--customrise {
  height: 80px;
  padding: 0 15vw;
  background: $color-yellow;
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 18px;
  color: $color-dark;
  z-index: 299 !important;

  @media screen and (max-width: 768px) {
    height: 120px;
    padding: 0 10vw;
  }

  > div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    @media screen and (max-width: 768px) {
      p {
        margin: 0 20px 0 0;
      }

      margin: 15px 0 0;
    }
  }

  a {
    color: $color-dark;
  }

  .Cookie__button {
    display: inline-block;
    margin: 0;
    padding: 7px 15px !important;
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    text-decoration: none;
    color: $color-dark;
    border: 1px solid $color-dark;
    box-sizing: border-box;
    border-radius: 80px;
    transition: all 0.3s ease;
    outline: none;
    background: $color-yellow;

    &:hover {
      cursor: pointer;
      background: $color-dark;
      color: $color-yellow;
      text-shadow: none;
    }

    @media screen and (max-width: 760px) {
      margin: 0 auto;
      padding: 0;
      font-size: 10px;
    }

    @media screen and (max-width: 1280px) {
      padding: 10px;
      font-size: 10px;
    }
  }
}
</style>
